export enum CriticalIndicatorChartFilters {
  week = "Week",
  month = "Month",
  quarter = "Quarter",
  year = "Year",
  custom = "Custom",
}
